import { Checkbox_, IconSvg, LimitCharacters, Main_Plain, Partial_Loader, Table, TableDesktop, TD, TH, THead, TR } from 'monica-alexandria'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled, { css, keyframes } from 'styled-components'
import { prettifyExcelDates } from '../../../utils/prettifiers'
import useDragScroll from '../../../hooks/useDragScroll'

const DashboardLeads = styled.div`
    padding: 0 2rem 4rem;
    td,th{
        white-space: nowrap;
    }
`

const flashHighlight = keyframes`
  0% { background-color: rgba(255,255,255,0); }
  50% { background-color: rgba(255,255,255,0.15); }
  100% { background-color: rgba(255,255,255,0); }
`;
const DashboardLeadsWrapper = styled.div`
    /* max-width: 100%;
    overflow-x: auto;
    cursor: grab;  */

     max-width: 100%;
    overflow-x: auto;
    cursor: grab;
    user-select: text;

    tr{
        cursor: pointer;
    }
`

const DashboardLeadsNo = styled.div`
    text-align: center;

    img{
        width: 100%;
        display: block;
        max-width: 40rem;
        margin: 2rem auto;
        opacity: .5;
    }

    h1,h5{
        color: var(--greyDark);
    }
`
const CrmTHead = styled(THead)`

`

const CopyWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  position: relative;
  padding: var(--smallPads); /* for nicer highlight */
  border-radius: var(--smallRadius);

  ${({ copied }) =>
    copied &&
    css`
      animation: ${flashHighlight} 0.8s ease-out;
    `}
    svg{
        &:hover  {
            opacity: 1;
            /* transform: translateY(0); */
        }
    }
`;



const CopyIconContainer = styled.div`
 
  svg{
    opacity: 0.4;
    transition: all 0.2s ease;
    transform: translateY(2px);
    width: 1.5rem;
    fill: ${p=>p.theme.color};
  }
 
`;

const Tooltip = styled.div`
  position: absolute;
  top: -3rem;
  left: 0;
  background: var(--mainLight);
  padding: var(--smallPads);
  border-radius: var(--smallRadius);
  white-space: nowrap;
  opacity: ${p => (p.show ? 1 : 0)};
  transform: translateY(${p => (p.show ? "0" : "4px")});
  transition: all 0.2s ease;
  pointer-events: none;

  p{
    font-size: 1.2rem;
  }
`;


const LeadSelectionCell = styled(TD)`
    width: 5rem;
`

const LeadSelectionHeader = styled(TH)`
    width: 5rem;
`
const DashboardLeadsLoadStatus = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
`
const CrmTableColumnLabel = styled.div`
    background: ${p=> p.columnColor+33};
    border: 1px solid ${p=> p.columnColor};
    color: #fff;
    padding: var(--smallPads);
    border-radius: var(--smallRadius);
    width: fit-content;
`
const CrmTable = styled(Table)`


`
export default function Crm_Leads_Table(props) {

      const {t} = useTranslation();
    //   const [leadColumnMap, setLeadColumnMap] = useState({});
        const wrapperRef = useRef(null);
        const headerRef = useRef(null);
    
    

        const [copiedField, setCopiedField] = useState(null);

       const copyToClipboard = (text, fieldId) => {
            if (!text) return;

            navigator.clipboard.writeText(text);
            setCopiedField(fieldId);

            setTimeout(() => setCopiedField(null), 1500);
        };

        useDragScroll(wrapperRef, headerRef);
        // const [pagination, setPagination] = useState({
        //     pageNo: 0,
        //     numOfDocuments: 10,
        //     leads: []
        // })
        const [multipleCustomFields, setMultipleCustomFields] = useState([])


        const check_for_existing_lead_field = (leads, fieldName) => {

                if (!leads?.length) return false;

                let detected = false;

                leads.forEach(lead => {
                    if (fieldName == 'CustomField' && (typeof(lead?.CustomField) == 'string' || lead?.CustomField?.key || lead?.CustomField?.length)) {
                        detected = true;
                    }
                    else if (lead[fieldName] && fieldName !== 'CustomField') detected = true;
                })

                return detected;
            }

        const updateLeadColumn = (leadId, newColumnId) => {
            props.setLeadColumnMap(prev => ({
                ...prev,
                [leadId]: newColumnId
            }));
        };

         useEffect(() => {
        if (props.registerColumnUpdater) {
           props.registerColumnUpdater(updateLeadColumn);
        }
    }, []);

    const visibleLeadIds = props.pagination?.leads?.map((lead) => String(lead._id)) || [];
    const selectedLeadIds = props.selectedLeadIds || [];
    const allVisibleSelected =
        visibleLeadIds.length > 0 &&
        visibleLeadIds.every((leadId) => selectedLeadIds.includes(leadId));

    const loadMoreRef = useRef(null);
    const { pagination, get_leads } = props;
    useEffect(() => {
        const marker = loadMoreRef.current;
        if (!marker || !pagination?.leads?.length || !pagination.hasMore || pagination.loading || pagination.error || typeof IntersectionObserver === 'undefined') return;
        let active = true;
        const observer = new IntersectionObserver(entries => {
            if (active && entries.some(entry => entry.isIntersecting)) get_leads(pagination.pageNo + 1);
        }, { rootMargin: '0px 0px 240px 0px' });
        observer.observe(marker);
        return () => { active = false; observer.disconnect(); };
    }, [get_leads, pagination]);

    console.log('props.columns', props.columns);
    console.log(' props.pagination?.leads', props.pagination?.leads);

    console.log('leadColumnMap', props.leadColumnMap);
    

  return (
    <DashboardLeads>
        {props.pagination?.leads?.length ?
            <DashboardLeadsWrapper ref={wrapperRef}  >
                <TableDesktop  alwaysVisible>
                    <CrmTable ref={headerRef} >
                        <CrmTHead >
                            {props.selectionMode ? (
                                <LeadSelectionHeader>
                                    <Checkbox_
                                        type="checkbox"
                                        checked={allVisibleSelected}
                                        onChange={() => props.toggleSelectAllVisible?.(visibleLeadIds)}
                                    />
                                </LeadSelectionHeader>
                            ) : null}
                            {check_for_existing_lead_field(props.pagination?.leads, "createdAt") ?
                                <TH>{t("Date")}</TH> 
                            : null}
                            {check_for_existing_lead_field(props.pagination?.leads,"Name") ?
                                <TH>{t("First name")}</TH>
                            : null}
                            {check_for_existing_lead_field(props.pagination?.leads,"Surname") ?
                                <TH>{t("Last name")}</TH>
                            :null}
                            {check_for_existing_lead_field(props.pagination?.leads,"FullName") ?
                                <TH>{t("Full name")}</TH>
                            :null}
                            {check_for_existing_lead_field(props.pagination?.leads,"City") ?
                                <TH>{t("City")}</TH>
                            :null}
                            {check_for_existing_lead_field(props.pagination?.leads,"Tel") ?
                                <TH>{t("Phone number")}</TH>
                            :null}
                            {check_for_existing_lead_field(props.pagination?.leads,"Email") ?
                                <TH>{t("Email address")}</TH>
                            :null}
                            {check_for_existing_lead_field(props.pagination?.leads, "CustomField") ? 
                                props.multipleCustomFields.headers.map(header =>(
                                    <TH key={header}>{header}</TH>
                                ))
                            :null }
                        </CrmTHead>
                            {props.pagination?.leads?.map((lead, i) => {
                                // const colId = props.leadColumnMap[lead._id]; 

                                const colId =
                                    props.leadColumnMap[lead._id] ||
                                    Object.keys(props.columns).find(colKey =>
                                        props.columns[colKey]?.items?.some(item => item._id === lead._id)
                                );


                                console.log('colId', colId);
                                
                                const col = props.columns?.[colId];

                                console.log('col', col);
                                return(
                                <TR 
                                    onClick={(e) => {
                                        const wrapper = wrapperRef.current;

                                        // prevent click if drag happened
                                        if (wrapper?.isDragging) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                        return;
                                        }

                                        if (props.selectionMode) {
                                            props.toggleLeadSelection?.(lead._id);
                                            return;
                                        }

                                        props.onClick(colId, lead);
                                    }} key={i} id={i}>
                                    {props.selectionMode ? (
                                        <LeadSelectionCell onClick={(e) => e.stopPropagation()}>
                                            <Checkbox_
                                                type="checkbox"
                                                checked={selectedLeadIds.includes(String(lead._id))}
                                                onChange={() => props.toggleLeadSelection?.(lead._id)}
                                            />
                                        </LeadSelectionCell>
                                    ) : null}
                                    {check_for_existing_lead_field(props.pagination?.leads, "createdAt") ?
                                     <TD>
                                        <CopyWrapper copied={copiedField === `createdAt-${lead._id}`}>
                                            <span>{prettifyExcelDates(lead.createdAt) || "N/A"}</span>

                                            {lead.createdAt && (
                                            <CopyIconContainer
                                                onClick={(e) => {
                                                e.stopPropagation();
                                                copyToClipboard(prettifyExcelDates(lead.createdAt), `createdAt-${lead._id}`);
                                                }}
                                                className="copy-icon"
                                            >
                                                <IconSvg Icon="Copy" />
                                            </CopyIconContainer>
                                            )}

                                            <Tooltip show={copiedField === `createdAt-${lead._id}`}>{t("Copied!")}</Tooltip>
                                        </CopyWrapper>
                                        </TD>
                                    : null }
                                        {check_for_existing_lead_field(props.pagination?.leads,"Name") ?
                                        <TD>
                                        <CopyWrapper copied={copiedField === `name-${lead._id}`}>
                                            <span>{lead.Name || "N/A"}</span>

                                            {lead.Name && (
                                            <CopyIconContainer
                                                onClick={(e) => {
                                                e.stopPropagation();
                                                copyToClipboard(lead.Name, `name-${lead._id}`);
                                                }}
                                                className="copy-icon"
                                            >
                                                <IconSvg Icon="Copy" />
                                            </CopyIconContainer>
                                            )}

                                            <Tooltip show={copiedField === `name-${lead._id}`}>{t("Copied!")}</Tooltip>
                                        </CopyWrapper>
                                        </TD>

                                    : null }
                                    {check_for_existing_lead_field(props.pagination?.leads,"Surname") ?
                                     <TD>
                                        <CopyWrapper copied={copiedField === `surname-${lead._id}`}>
                                            <span>{lead.Surname || "N/A"}</span>

                                            {lead.Surname && (
                                            <CopyIconContainer
                                                onClick={(e) => {
                                                e.stopPropagation();
                                                copyToClipboard(lead.Surname, `surname-${lead._id}`);
                                                }}
                                                className="copy-icon"
                                            >
                                                <IconSvg Icon="Copy" />
                                            </CopyIconContainer>
                                            )}

                                            <Tooltip show={copiedField === `surname-${lead._id}`}>{t("Copied!")}</Tooltip>
                                        </CopyWrapper>
                                        </TD>

                                    : null }
                                    {check_for_existing_lead_field(props.pagination?.leads,"FullName") ?
                                    <TD>
                                    <CopyWrapper copied={copiedField === `fullname-${lead._id}`}>
                                        <span>{lead.FullName || "N/A"}</span>

                                        {lead.FullName && (
                                        <CopyIconContainer
                                            onClick={(e) => {
                                            e.stopPropagation();
                                            copyToClipboard(lead.FullName, `fullname-${lead._id}`);
                                            }}
                                            className="copy-icon"
                                        >
                                            <IconSvg Icon="Copy" />
                                        </CopyIconContainer>
                                        )}

                                        <Tooltip show={copiedField === `fullname-${lead._id}`}>{t("Copied!")}</Tooltip>
                                    </CopyWrapper>
                                    </TD>

                                    : null}
                                    {check_for_existing_lead_field(props.pagination?.leads,"City") ?
                                       <TD>
                                            <CopyWrapper copied={copiedField === `city-${lead._id}`}>
                                                <span>{lead.City || "N/A"}</span>

                                                {lead.City && (
                                                <CopyIconContainer
                                                    onClick={(e) => {
                                                    e.stopPropagation();
                                                    copyToClipboard(lead.City, `city-${lead._id}`);
                                                    }}
                                                    className="copy-icon"
                                                >
                                                    <IconSvg Icon="Copy" />
                                                </CopyIconContainer>
                                                )}

                                                <Tooltip show={copiedField === `city-${lead._id}`}>{t("Copied!")}</Tooltip>
                                            </CopyWrapper>
                                            </TD>

                                    : null}
                                      {check_for_existing_lead_field(props.pagination?.leads,"Tel") ? (
                                    <TD>
                                        <CopyWrapper
                                            copied={copiedField === `tel-${lead._id}`}
                                            
                                        >
                                            <h6>{lead.Tel || "N/A"}</h6>

                                            {lead.Tel && (
                                            <CopyIconContainer  onClick={(e) => {
                                            e.stopPropagation();
                                            copyToClipboard(lead.Tel, `tel-${lead._id}`);
                                            }} className="copy-icon">
                                                <IconSvg Icon="Copy" />
                                            </CopyIconContainer>
                                            )}

                                            <Tooltip show={copiedField === `tel-${lead._id}`}><p>{t('Copied!')}</p></Tooltip>
                                        </CopyWrapper>
                                    </TD>


                                    ) : null}

                                    {check_for_existing_lead_field(props.pagination?.leads,"Email") ?
                                       <TD>
                                            <CopyWrapper
                                                copied={copiedField === `email-${lead._id}`}
                                               
                                            >
                                                <span>{lead.Email || "N/A"}</span>

                                                {lead.Email && (
                                                <CopyIconContainer 
                                                     onClick={(e) => {
                                                    e.stopPropagation();
                                                    copyToClipboard(lead.Email, `email-${lead._id}`);
                                                }}
                                                 className="copy-icon">
                                                    <IconSvg Icon="Copy" />
                                                </CopyIconContainer>
                                                )}

                                                <Tooltip show={copiedField === `email-${lead._id}`}>{t('Copied!')}</Tooltip>
                                            </CopyWrapper>
                                        </TD>
                                    : null}
                                 {props.multipleCustomFields.headers.map(header => (
                                    <TD key={header}>
                                        <CopyWrapper copied={copiedField === `${header}-${lead._id}`}>
                                        <span>{LimitCharacters(props.multipleCustomFields.data[i][header], 30)   || "N/A"}</span>

                                        {props.multipleCustomFields.data[i][header] && (
                                            <CopyIconContainer
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                copyToClipboard(props.multipleCustomFields.data[i][header], `${header}-${lead._id}`);
                                            }}
                                            className="copy-icon"
                                            >
                                            <IconSvg Icon="Copy" />
                                            </CopyIconContainer>
                                        )}

                                        <Tooltip show={copiedField === `${header}-${lead._id}`}>{t("Copied!")}</Tooltip>
                                        </CopyWrapper>
                                    </TD>
                                    ))}

                                    <TD>
                                        {col ? (
                                            <CrmTableColumnLabel columnColor={col.color}>
                                                <h6>{col.title}</h6>
                                            </CrmTableColumnLabel>
                                        ) : "N/A"}
                                    </TD>
                                </TR>
                            )}
                    )}
                    </CrmTable>
                </TableDesktop>
            </DashboardLeadsWrapper>
        :
            !pagination?.loading && !pagination?.error ? <DashboardLeadsNo>
                <img src='https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Empty.svg' />
                <h1>{t("No leads available")}</h1>
                <h5>{t("There are no available leads to show at the moment. Come back later to check again!")}</h5>
            </DashboardLeadsNo> : null
        }
        {(pagination?.hasMore || pagination?.loading || pagination?.error) && (
            <DashboardLeadsLoadStatus>
                <div ref={loadMoreRef} aria-hidden="true" style={{ width: '100%', height: 1 }} />
                {pagination.loading && <div role="status" aria-label={t('Loading more leads')}>
                    <Partial_Loader />
                    <span>{t('Loading more leads')}</span>
                </div>}
                {pagination.error && <div role="alert">
                    <p>{t('Could not load leads. Please try again.')}</p>
                    <Main_Plain text={t('Retry')} onClick={() => get_leads(pagination.retryPage ?? (pagination.leads.length ? pagination.pageNo + 1 : 0))} />
                </div>}
            </DashboardLeadsLoadStatus>
        )}
    </DashboardLeads>
  )
}
